module.exports = __webpack_public_path__ + "img/picture_wxzxjc.10b817f9.png";